export class CanceledEvent {
    constructor({ cancelDate }) {
        this.name = 'canceled';
        this.cancelDate = cancelDate;
    }
    get data() {
        return {
            cancelDate: this.cancelDate,
        };
    }
}
